import { useLazyQuery } from '@apollo/client';
import { Flex, Spinner } from '@chakra-ui/react';
import TextLink from '@components/interactive/TextLink';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import { FontSizes } from 'chakra-ui/fsmTheme';
import { GET_SUMMARY_OF_BENEFITS } from 'gql/SummaryOfBenefitsForUser';
import { useEffect, useState } from 'react';

function SummaryOfBenefitsLink({ cms_id, effective_date, ...rest }) {
  const [summaryURL, setSummaryURL] = useState('');
  const [linkError, setLinkError] = useState(false);

  const { setAuthenticatedUser, authenticatedUser: user } = useAuthenticatedContextProvider();

  const [getSummaryOfBenefits, { loading, error, data }] = useLazyQuery(GET_SUMMARY_OF_BENEFITS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      const docArray = data?.getSummaryOfBenefitsForUser?.documents;
      if (docArray) {
        const summaryOfBenefitsDoc = docArray.find((doc) => {
          const name = doc.Name.toLowerCase();
          const linkName = doc.LinkName.toLowerCase();
          return name.includes('summary') || linkName.includes('summary');
        });

        let planKey;
        let plan;

        for (const [key, value] of Object.entries(user)) {
          if (value && (value as any).cms_id === cms_id) {
            plan = value;
            planKey = key;
          }
        }

        setAuthenticatedUser((user) => {
          return {
            ...user,
            [planKey]: {
              ...plan,
              summaryOfBenefits: summaryOfBenefitsDoc?.Url,
            },
          };
        });
        setSummaryURL(summaryOfBenefitsDoc?.Url);
      } else {
        // if call returns null values
        setLinkError(true);
      }
    },
  });

  /** makes call to get summary of benefits on page load */
  useEffect(() => {
    function filterSummaryVariables() {
      const splitCMS = cms_id.split('_');
      const h_number = splitCMS[0];
      const plan_id = splitCMS[1];
      const segment_id = splitCMS[2] || null;
      getSummaryOfBenefits({
        variables: {
          h_number,
          plan_id,
          segment_id,
          effective_date,
        },
      });
    }
    if (cms_id) filterSummaryVariables();
  }, []);

  /** If error in gql, connecture API, don't display link */
  if (error || linkError) {
    return null;
  }

  if (loading) {
    return (
      <Flex w={['120px', '120px', '150px']} justifyContent="center">
        <Spinner thickness="2px" speed="0.65s" emptyColor="gray.200" color="blue.500" />
      </Flex>
    );
  }

  if (!summaryURL) {
    return null;
  }

  return (
    <TextLink
      id="mapdPdpSummaryOfBenefitsLink"
      text="See Plan Details"
      href={summaryURL}
      target="_blank"
      fontSize={[FontSizes.body1.mobile, FontSizes.body1.mobile, FontSizes.body1.desktop]}
      {...rest}
    />
  );
}

export default SummaryOfBenefitsLink;
